import $ from "jquery";
import {message} from "antd";
import {buildInsertPicHtml} from "../../toolsSpace/tools/pictureTool/pictureTool";
import {buildInsertVideoHtml} from "../../toolsSpace/tools/videoTool/videoTool";
export default function changeImage(content, picList){
    console.log("picList:  ", picList);
    let $div = $(`<div>${content}</div>`);
    $div.find("img").each(function(){
        let src = $(this).attr("src");
        let aliasLabel=$(this).attr("alias-label");
        if(!src){
            message.error("图片转换错误！存在图片src为空的情况");
            $(this).remove();
        }else{
            let exist = false;
            for(let i = 0 ; picList && i < picList.length; i++){
                let pic = picList[i];
                if(pic?.path === src || pic?.smallPath === src || pic?.thumbnailsPlayPath=== src || pic?.waterPath === src){
                    exist = true;
                    if (aliasLabel==='video') {
                        $(this).after(buildInsertVideoHtml({url: pic.mp4Path, playUrl: pic.thumbnailsPlayPath, videoPic: pic.thumbnailsPath, sourceUrl:pic.mp4Path, title:pic.name,duration:pic.duration, name:pic.name,}));
                    }else {
                        if (eval(window.sysConfigGetValueByKey("editor.wordimport.showwaterpath"))) {
                            $(this).after(buildInsertPicHtml({ url: pic.waterPath, sourceUrl: pic.path, title: pic.name, name: pic.name, isWrapperP: false }));
                        } else {
                            $(this).after(buildInsertPicHtml({ url: pic.smallPath, sourceUrl: pic.path, title: pic.name, name: pic.name, isWrapperP: false }));
                        }
                    }
                    $(this).remove();
                    break;
                }
            }
            if(!exist){
                message.error("图片转换错误！存在图片src未在云存储中找到完整信息的情况");
                $(this).remove();
            }
        }
    });
    return $div.html();
}